import postscribe from 'postscribe';
import 'isomorphic-fetch';

import { lastGlobalAction } from 'Actions/GlobalMetaActions';
import { devicePlatform } from 'Utils/deviceType';
import { parsePath } from 'Utils/nav/NavHelpers';

export const GEOLOCATION = 'GEOLOCATION';
export const SHOW_INTERSTITIAL = 'SHOW_INTERSTITIAL';
export const HIDE_INTERSTITIAL = 'HIDE_INTERSTITIAL';
export const SAVE_AD_SLOT = 'SAVE_AD_SLOT';
export const DELETE_AD_SLOT = 'DELETE_AD_SLOT';
export const SHOW_AD_SLOT = 'SHOW_AD_SLOT';
export const HIDE_AD_SLOT = 'HIDE_AD_SLOT';
export const ADS_PERMISSIONS = 'ADS_PERMISSIONS';
export const RESET_HIDDEN_ADS = 'RESET_HIDDEN_ADS';
export const SET_GPTCORRELATOR = 'SET_GPTCORRELATOR';
export const DOCUMENT_VISIBLE = 'DOCUMENT_VISIBLE';

let insertedNodes = [],
	useSSL = 'https:' === document.location.protocol,
	_exelateURL = '',
	pageCounter = 0,
	isUserLoggedIn = false,
	adsPermissions = { noAdsPermissions: false, secondaryAds: false },
	bodyDOM = document.body || document.getElementsByTagName( 'body' )[ 0 ],
	headDOM = document.head || document.getElementsByTagName( 'head' )[ 0 ],
	is = {
		VS: false,
		Lotame: false,
		prebid: ( typeof prebid_adUnits_def !== 'undefined' && prebid_adUnits_def && prebid_adUnits_def.length > 0 ),
		taboola: false,
		taboola_widget: false,
		sharethrough: false,
		VSInterstitial: false,
		homePageInContentAdUnit: false,
		netSeer: false
	},
	loaded = {
		events: null,
		Lotame: false,
		Lotame_ccauds: false,
		VSAPI: false,
		comScore: false,
		viglink: false,
		customs: false,
		sharethrough: false,
		netSeer: false
	};

const analyticsTrackerName = 'Topify';
window.PREBID_TIMEOUT = 700;
const geoLocationRefresh = 60000; // 60 secs

// Action creators
function setGeoLocation( location = {allow: true, error: false, latitude: '', longitude: '', timestamp: 0} ) {
	return {
		type: GEOLOCATION,
		location
	}
}
export function showInterstitial() {
	return {
		type: SHOW_INTERSTITIAL
	}
}
export function resetHiddenAdsPerUser() {
	return {
		type: RESET_HIDDEN_ADS
	}
}
export function hideInterstitial() {
	return {
		type: HIDE_INTERSTITIAL
	}
}
export function saveAdSlot( slotName, adUnit ) {
	return {
		type: SAVE_AD_SLOT,
		slotName,
		adUnit
	}
}
export function deleteAdSlot( slotName ) {
	return {
		type: DELETE_AD_SLOT,
		slotName
	}
}
export function showAdSlot( slotName ) {
	return {
		type: SHOW_AD_SLOT,
		slotName
	}
}
export function hideAdSlot( slotName ) {
	return {
		type: HIDE_AD_SLOT,
		slotName
	}
}
export function setAdsPermissions( values = { noAdsPermissions: false, secondaryAds: false } ) {
	return {
		type: ADS_PERMISSIONS,
		values
	}
}
export function setGPTCorrelator( refresh ) {
	return {
		type: SET_GPTCORRELATOR,
		refresh: refresh
	}
}
export function setDocumentVisibility( visible ) {
	return {
		type: DOCUMENT_VISIBLE,
		visible: visible
	}
}

function getBody() {
	if( !bodyDOM ) {
		bodyDOM = document.body || document.getElementsByTagName( 'body' )[ 0 ];
	}
	return bodyDOM;
}
function getHead() {
	if( !headDOM ) {
		headDOM = document.head || document.getElementsByTagName( 'head' )[ 0 ];
	}
	return headDOM;
}

// Is VS
function isVS( state ) {
	const forumSite = state.topifyPresets.forumSite;
	is.VS = ( parseInt( forumSite.isVS ) === 1 );
	return is.VS;
}
// VS API
function loadVSAPI( state ) {
	if( is.VS && is.Lotame && process.env.NODE_ENV === 'production' ) {
		postscribe(
			getBody(),
			'<script id="vsapi_js" type="text/javascript" src="//d1r55yzuc1b1bw.cloudfront.net/vsapi.all.min.js"></script>',
			{
				done: function() {
					topifyConsole.info( "loading vsapi js tag" );
					loaded.VSAPI = true;
					initVSAPI( state );
				},
				error: function() {
					topifyConsole.warn( 'error loading: VSAPI' );
				}
			}
		);
	}
}
function initVSAPI( state ) {
	// Inititating vsAPI
	if( typeof vsapi !== 'undefined' ) {
		let vs_api = vsapi.api();
		window._vs_observe = new vs_api.PostReadObserve();
		_vs_observe.debug = !( process.env.NODE_ENV === 'production' ); // log debug visibility and callback info, turn off in prod
		window._vs_beacon = new vs_api.PostReadBeacon( _vs_observe, state.ustate.id, 'https://api.verticalscope.com' );
		window._vs_lotame = new vs_api.LotameBeacon( _vs_observe );

		_vs_observe.init();
		_vs_beacon.init();
		topifyConsole.log( "vsAPI init" );

		refreshVSAPI( state );

	} else if( is.VS && is.Lotame ) {
		topifyConsole.log( 're initVSAPI' );
		setTimeout( function() { initVSAPI( state ) }, 500 );
	}
}
// Events
function initEvents( dispatch ) {
	document.addEventListener( 'visibilitychange', () => focusChange( dispatch ) );
	focusChange( dispatch )
}
function focusChange( dispatch ) {
	topifyConsole.log( 'visibility change', !document.hidden, document.visibilityState );
	cleanOldAdElements();
	dispatch( setDocumentVisibility( !document.hidden ) );
}
// Ads ------
// Load Libraries: prebid, googletag, analytics ...
let loadLibraries = function( state ) {
	return new Promise( ( resolve ) => {
		window.googletag = window.googletag || {};
		window.googletag.cmd = window.googletag.cmd || [];

		window._gaq = window._gaq || [];

		if( is.prebid ) {
			window.pbjs = window.pbjs || {};
			window.pbjs.que = window.pbjs.que || [];
		}

		// Set up Google Analytics
		(function() {
			let gaq = document.createElement( 'script' );
			gaq.type = 'text/javascript';
			gaq.async = true;
			gaq.src = (useSSL ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
			let s = document.getElementsByTagName( 'script' )[ 0 ];
			s.parentNode.insertBefore( gaq, s );
		})();

		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
			(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
			m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

		ga( function() {
			ga( 'create', 'UA-36870210-7', { name: analyticsTrackerName } );

			// Set the session scope appType dimension to the appropriate application type.
			// Defined dimensions:
			// dimension1 = forumId - hit
			// dimension2 = appType - session
			// dimension3 = forumUserGroup - hit
			ga( analyticsTrackerName + '.set', 'dimension2', 'react_v1' );

			// appName
			ga( analyticsTrackerName + '.set', 'appName', 'Topify Browser V3' );
			// hostname
			ga( analyticsTrackerName + '.set', 'hostname', state.topifyPresets.forumSite.f_site_name );

			topifyConsole.info( 'GA - create tracker: ' + analyticsTrackerName );

			if( state.topifyPresets.forumSite.f_analytics_id ) {
				ga( 'create', state.topifyPresets.forumSite.f_analytics_id, { name: state.topifyPresets.forumSite.f_id } );
				topifyConsole.info( 'GA - create tracker: ' + state.topifyPresets.forumSite.f_analytics_id + ' - forumId: ' + state.topifyPresets.forumSite.f_id );
			}
		});

		// AFS ads
		(function( G, o, O, g, L, e ) {
			G[ g ] = G[ g ] || function() {
					(G[ g ][ 'q' ] = G[ g ][ 'q' ] || []).push(
						arguments )
				}, G[ g ][ 't' ] = 1 * new Date;
			L = o.createElement( O ), e = o.getElementsByTagName(
				O )[ 0 ];
			L.async = 1;
			L.src = '//www.google.com/adsense/search/async-ads.js';
			e.parentNode.insertBefore( L, e )
		})( window, document, 'script', '_googCsa' );

		// Prepare prebid loading
		// fallback to ga
		function initAdserver() {
			if ( is.prebid ) {
				if( pbjs.adserverRequestSent ) {
					return;
				}
				pbjs.adserverRequestSent = true;
			}

			(function() {
				let gads = document.createElement( 'script' );
				gads.async = true;
				gads.type = 'text/javascript';
				gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
				let node = document.getElementsByTagName( 'script' )[ 0 ];
				node.parentNode.insertBefore( gads, node );
			})();

			if( is.prebid ) {
				// resolve the promise
				resolve( true );
			} else {
				resolve( false );
			}
		}

		setTimeout( initAdserver, window.PREBID_TIMEOUT );

		if( is.prebid ) {
			// Loading prebid
			(function() {
				let pbjsEl = document.createElement( "script" );
				pbjsEl.type = "text/javascript";
				pbjsEl.async = true;
				pbjsEl.src = "//dz2fz0bgyq9tn.cloudfront.net/prebid-0.16.0-v1.js";
				let pbjsTargetEl = getHead();
				pbjsTargetEl.insertBefore( pbjsEl, pbjsTargetEl.firstChild );
			})();

			// enabling analytics
			pbjs.que.push( function() {
				// Add the below code snippet to your page
				pbjs.enableAnalytics({
					provider: 'ga',
					options: {
						trackerName: analyticsTrackerName,
						global: 'ga', // <string> name of GA global. Default is 'ga'
						enableDistribution: false
					}
				});
			} );

			// setting adUnits
			pbjs.que.push( function() {
				pbjs.bidderSettings = {
					standard: {
						alwaysUseBid: false,
						adserverTargeting: [ {
							key: "hb_bidder",
							val: function( bidResponse ) {
								topifyConsole.log( 'hb_bidder', bidResponse );
								return bidResponse.bidder;
							}
						}, {
							key: "hb_adid",
							val: function( bidResponse ) {
								return bidResponse.adId;
							}
						}, {
							key: "hb_pb",
							val: function( bidResponse ) {
								let cpm = bidResponse.cpm;
								if( cpm < 0.1 ) cpm = 0.10;
								if( cpm > 8 ) cpm = 20.00;
								let newCpm = (Math.floor( cpm * 10 ) / 10).toFixed( 2 );
								return "pb" + newCpm.replace( ".", "" );
							}
						}, {
							key: "hb_size",
							val: function( bidResponse ) {
								return bidResponse.size;
							}
						} ]
					}
				};

				pbjs.requestBids( {
					bidsBackHandler: function( bidResponses ) {
						initAdserver();
					}
				} );
			} );

			// normalizing prebid adUnits definitions: ensure we are using the correct sizes int values
			try {
				prebid_adUnits_def = prebid_adUnits_def.map( function( ad ) {
					ad.sizes = ad.sizes.map( function( sizes ) {
						return sizes.map( function( size ) {
							return parseInt( size );
						} );
					} );
					return ad;
				} );
			} catch( e ) {
				topifyConsole.error( 'Prebid normalizing Error:', e );
			}
		}
	} );
};
function initGoogleAds( state ) {
	window.googletag = window.googletag || {};
	window.googletag.cmd = window.googletag.cmd || [];

	window._gaq = window._gaq || [];

	if( is.prebid ) {
		window.pbjs = window.pbjs || {};
		window.pbjs.que = window.pbjs.que || [];
	}

	topifyConsole.log( 'DEFINED: googletag, _gaq, pbjs' );

	const forumSite = state.topifyPresets.forumSite,
		googleKeywords = JSON.parse( forumSite.dfpTargets );

	loadLibraries( state ).then( function() {
		topifyConsole.log( 'Targetting googleads' );

		window.googletag.cmd.push( () => {
			//ForumSite Name Targeting
			googletag.pubads().setTargeting( 'sitename', forumSite.f_site_name );

			//Custom Targeting
			for( let key in googleKeywords ) {
				if( googleKeywords.hasOwnProperty( key ) ) {
					googletag.pubads().setTargeting( key, googleKeywords[ key ] );
				}
			}

			// Set the GPS info. that is only gathered once when the web app loads.
			//GEO Location
			if( state.ads.geoLocation.latitude && state.ads.geoLocation.longitude ) {
				topifyConsole.log( 'setting googletag location' );
				googletag.pubads().setLocation( state.ads.geoLocation.latitude, state.ads.geoLocation.longitude );
			}

			topifyConsole.log( 'setting other googletag options' );

			googletag.pubads().setCentering( true );
			googletag.pubads().disableInitialLoad();

			// common settings
			googletag.enableServices();

			if( is.prebid ) {
				topifyConsole.log( 'setting prebid targeting' );

				pbjs.que.push( function() {
					pbjs.setTargetingForGPTAsync();
				} );
			}
		} );
	});
}

// Check other ad libraries functions
export function isLoggedIn() {
	return ( dispatch, getState ) => {
		isUserLoggedIn = !!( getState().ustate.id );
		return isUserLoggedIn;
	};
}
function hasCustomScripts( state ) {
	const forumSite = state.topifyPresets.forumSite;
	return ( forumSite.customscripts.length > 0 );
}
function isTaboola( state ) { // guests only, for now
	const forumSite = state.topifyPresets.forumSite;
	// check all taboola types
	is.taboola = !!( forumSite.f_taboola && !adsPermissions.noAdsPermissions && !isUserLoggedIn );
	is.taboola_widget = ( forumSite.f_taboola_widget && !adsPermissions.noAdsPermissions && !isUserLoggedIn ) ? forumSite.f_taboola_widget : false;
}
function isRevContent( state ) { // guests only, for now
	const forumSite = state.topifyPresets.forumSite;
	return !!( forumSite.f_revcontent && !isUserLoggedIn );
}
function isLotame( state ) {
	const forumSite = state.topifyPresets.forumSite;
	is.Lotame = !!( parseInt( forumSite.isVS ) === 1 && forumSite.f_lotame );
	return is.Lotame;
}
function isSwoop( state ) { // guests only
	const forumSite = state.topifyPresets.forumSite;
	return !!( forumSite.f_swoop && !isUserLoggedIn );
}
function isShareThrough( state ) {
	const forumSite = state.topifyPresets.forumSite;
	is.sharethrough = !!( parseInt( forumSite.isVS ) === 1 && forumSite.f_sharethrough );
	return is.sharethrough;
}
function isNetseer( state ) { // guests only
	let page = document.getElementById( 'page' );

	if( page === null ) {
		return false;
	}

	try {
		if( state.topifyPresets.forumSite.netseer_tag_id && !adsPermissions.noAdsPermissions && !isUserLoggedIn ) {
			window.netseer_tag_id = state.topifyPresets.forumSite.netseer_tag_id;
			window.netseer_publisher_label = state.topifyPresets.forumSite.f_site_name;
			page.classList.remove( 'no-ad' );
			return true;
		} else {
			delete window.netseer_tag_id;
			delete window.netseer_publisher_label;
			page.classList.add( 'no-ad' );
			return false;
		}
	} catch( e ) {
		topifyConsole.error( 'NetSeer failed to check', e );
		delete window.netseer_tag_id;
		delete window.netseer_publisher_label;
		return false;
	}
}
function usesIframeMessenger( state ) {
	const forumSite = state.topifyPresets.forumSite;
	let InterstitalAdUnit,
		homePageInContentAdUnit,
		tags = [];

	if( forumSite.dfpTags && parseInt( forumSite.isVS ) === 1 ) {
		tags = JSON.parse( forumSite.dfpTags );

		if( tags.length > 0 ) {
			InterstitalAdUnit = tags.find( function( ad ) {
				return ( parseInt( ad.at_id ) === 4 );
			} );
			homePageInContentAdUnit = tags.find( function( ad ) {
				return ( parseInt( ad.at_id ) === 101 );
			} );
		}
	}

	if( InterstitalAdUnit ) {
		is.VSInterstitial = true;
	}
	if( homePageInContentAdUnit ) {
		is.homePageInContentAdUnit = true;
	}

	return is.VSInterstitial || is.homePageInContentAdUnit;
}

function goInterstitial() {
	return ( pageCounter === 2 && is.VSInterstitial );
}

// Load libraries functions
function get_ExelateUrl( state ) {
	if( _exelateURL ) {
		return _exelateURL;
	}

	const forumSite = state.topifyPresets.forumSite;

	const _nativeAds = false; // Note: for now it's only web
	const _verticals = {
		'AUTO': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=285379&ctg=Automotive&cmake=%EX_MAKE%&cmodel=%EX_MODEL%',
		'COL': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927073&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%',
		'OH': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=118748&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%',
		'PETS': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=20208&ctg=Pets',
		'PE': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927260&ctg=OffRoadVehicles&vehicles=Tractors-Combines&new=no',
		'PS': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927260&ctg=OffRoadVehicles&vehicles=%EX_MAKE%',
		'RV': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=285379&ctg=Automotive&cmake=%EX_MAKE%&cmodel=%EX_MODEL%',
		'SP': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=23705&ctg=Sports&sprt=%EX_MAKE%',
		'TECH': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927073&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%'
	};

	let exelateUrl = '';

	if( forumSite.f_vertical ) {
		let vertical = forumSite.f_vertical.toUpperCase(),
			googleKeywords = JSON.parse( forumSite.dfpTargets );
		topifyConsole.log( 'Exelate: ' + vertical );
		topifyConsole.log( googleKeywords );

		if( _verticals.hasOwnProperty( vertical ) ) {
			exelateUrl = _verticals[ vertical ];

			exelateUrl = exelateUrl.replace( '%EXELATE%', forumSite.f_exelateid );

			if( exelateUrl.indexOf( '%EX_MAKE%' ) > -1 ) {
				if( googleKeywords.hasOwnProperty( 'make' ) ) {
					exelateUrl = exelateUrl.replace( '%EX_MAKE%', googleKeywords.make );
				} else {
					exelateUrl = exelateUrl.replace( '%EX_MAKE%', '' );
				}
			}

			if( exelateUrl.indexOf( '%EX_MODEL%' ) > -1 ) {
				if( googleKeywords.hasOwnProperty( 'model' ) ) {
					exelateUrl = exelateUrl.replace( '%EX_MODEL%', googleKeywords.model );
				} else {
					exelateUrl = exelateUrl.replace( '%EX_MODEL%', '' );
				}
			}

			// For native apps we need to add &APP=1
			exelateUrl = exelateUrl + ( _nativeAds ? '&APP=1' : '' );
		}
		topifyConsole.log( 'Exelate URL: ' + exelateUrl );
	}

	_exelateURL = exelateUrl;

	return _exelateURL;
}
function addCustomScripts( state ) {
	// Custom ads js
	if( hasCustomScripts( state ) ) {
		const forumSite = state.topifyPresets.forumSite;
		forumSite.customscripts.forEach( function( s_data, s_index ) {
			if( s_data['on_refresh'] || loaded.customs === false ) {
				let script_id = ( s_data['on_refresh'] ? '_delete' : '' ) + '_' + s_index;
				if( s_data[ 'url' ] ) {
					postscribe(
						getBody(),
						'<script id="customjs' + script_id + '" type="text/javascript" src="' + s_data[ 'url' ] + '"></script>',
						{
							done: function() {
								loaded.customs = true;
								topifyConsole.info( "loading custom js tag ", s_index )
							},
							error: function() {
								topifyConsole.warn( 'error loading: customScript', s_index );
							}
						}
					);
				}

				if( s_data[ 'code' ] ) {
					postscribe(
						getBody(),
						'<script id="customcode' + script_id + '" type="text/javascript">' + s_data[ 'code' ] + '</script>',
						{
							done: function() {
								loaded.customs = true;
								topifyConsole.info( "loading custom js code ", s_index )
							},
							error: function() {
								topifyConsole.warn( 'error loading: customCode', s_index );
							}
						}
					);
				}
			}
		} );
	}
}
function addVibrantjs( state ) {
	const vibrant_id = state.topifyPresets.forumSite.f_vibrant;
	if( vibrant_id ) {
		// Vibrant Media IntelliTXT
		postscribe(
			getBody(),
			'<script type="text/javascript" src="//aftest.us.intellitxt.com/intellitxt/front.asp?ipid=' + vibrant_id + '"></script>',
			{
				done: function() {
					topifyConsole.info( "loading vibrant js tag" );
				},
				error: function() {
					topifyConsole.warn( 'error loading: Vibrant' );
				}
			}
		);
	}
}
function addComScore( state ) {
	// Set up comScore functionality before attempting to record any tracking.
	let comscoreScript = `${ useSSL ? 'https://sb' : 'http://b' }.scorecardresearch.com/beacon.js`;

	postscribe(
		getBody(),
		'<script id="comScoreBeacon" type="text/javascript" async src="' + comscoreScript + '"></script>',
		{
			done: function () {
				loaded.comScore = true;
				topifyConsole.info("loading comscore js");
				trackComScore( state );
			},
			error: function() {
				topifyConsole.warn( 'error loading: ComScore');
			}
		}
	);
}
function trackComScore( state ) {
	const forumSite = state.topifyPresets.forumSite;
	let id = forumSite.f_comscoreid,
		siteName = forumSite.f_site_name;

	if( loaded.comScore && id ) {
		topifyConsole.log( 'trackComScore' );
		let internalTrackComScore = function(id, siteName, retryCount) {
			if( self.COMSCORE && self.COMSCORE.beacon ) {
				self.COMSCORE && COMSCORE.beacon({c1: "2", c2: id, c4: siteName})
			} else {
				if( retryCount < 6 ) {
					window.setTimeout( function() {
						internalTrackComScore(id, siteName, retryCount + 1);
					}, 500)
				}
			}
		};

		internalTrackComScore(id, siteName, 1);
	}
}
function addExelate( state ) {
	// get eXelate URL
	let exelateURL = get_ExelateUrl( state );

	if( exelateURL ) {
		let exURL = document.location.protocol + exelateURL;
		exURL += '&mobileidtype=' + devicePlatform();
		exURL += '&scantime=' + parseInt( Date.now() / 1000 ); // we only want 10 digits
		if( state.ads.geoLocation.latitude && state.ads.geoLocation.longitude ) {
			exURL += '&gpslat=' + state.ads.geoLocation.latitude;
			exURL += '&gpslong=' + state.ads.geoLocation.longitude;
		}
		exURL += '&j=d';

		fetch( exURL, {
			method: 'GET',
			mode: 'cors',
			cache: 'reload',
			credentials: 'include'
		}).then( function() {
			topifyConsole.info("ran exelate");
		}).catch(function(error) {
			topifyConsole.warn('Error running exelate: ' + error.message);
		});
	}
}
function addLotame() {
	// Lotame js tag only for VS sites
	if( is.Lotame && !loaded.Lotame ) {
		postscribe(
			getHead(),
			'<script id="LOTCC_8060" type="text/javascript" src="//tags.crwdcntrl.net/c/8060/cc_af_ajax.js?ns=_cc0" ></script>',
			{
				done: function() {
					topifyConsole.info( "loading Lotame js tag" );
					loaded.Lotame = true;
					refreshLotame();
				},
				error: function() {
					topifyConsole.warn( 'error loading: Lotame' );
				}
			}
		);
	}
}
function addLotame_ccauds() {
	// Lotame js tag only for VS sites
	if( is.Lotame && !loaded.Lotame_ccauds ) {
		postscribe(
			getHead(),
			'<script id="lotame_ccauds_js" type="text/javascript" src="//ad.crwdcntrl.net/5/c=8059/pe=y/var=ccauds" ></script>',
			{
				done: function() {
					topifyConsole.info( "loading Lotame_ccauds js tag" );
					loaded.Lotame_ccauds = true;
					setTargetingLotame_ccauds();
				},
				error: function() {
					topifyConsole.warn( 'error loading: Lotame_ccauds' );
				}
			}
		);
	}
}

function addSwoop( state ) {
	// swoop code every page view
	if( isSwoop( state ) ) {
		let swoopID = state.topifyPresets.forumSite.f_swoop,
			serverbase = ( useSSL ? 'https:' : 'http:' ) + '//ardrone.swoop.com/',
			src = serverbase + 'js/spxw.js';

		postscribe(
			getBody(),
			"<script id='swoop_sdk' data-domain='" + swoopID + "' data-serverbase='" + serverbase + "' type='text/javascript' src='" + src + "'></script>",
			{
				done: function () {
					topifyConsole.info("loading swoop code");
				},
				error: function() {
					topifyConsole.warn( 'error loading: swoop');
				}
			}
		);
	}
}
function loadViglink( state ) {
	const forumSite = state.topifyPresets.forumSite,
		sectionsOk = ['thread'];
	let page = document.getElementById( 'page' );

	if(
		sectionsOk.indexOf( lastGlobalAction.type ) >= 0 &&
		forumSite.f_vigkey &&
		forumSite.f_vigkey.length > 0
	) {
		// VigLink
		// Note that, for VS sites, we only use VigLink for guest users.
		if( !isVS( state ) || ( isVS( state ) && !isUserLoggedIn ) ) { // we are in guest only
			page.classList.remove( 'nolinks', 'nooptimize', 'norewrite' );

			if( !loaded.viglink ) {
				postscribe(
					getBody(),
					"<script type='text/javascript'>var vglnk = { api_url: '//api.viglink.com/api',key: '" + forumSite.f_vigkey + "'};(function(d, t) {var s = d.createElement(t); s.type = 'text/javascript'; s.async = true;s.src = ('https:' == document.location.protocol ? vglnk.api_url:'//cdn.viglink.com/api') + '/vglnk.js';var r = d.getElementsByTagName(t)[0]; r.parentNode.insertBefore(s, r);}(document, 'script'));</script>",
					{
						done: function() {
							topifyConsole.info( 'loading viglink js' );
							loaded.viglink = true;
						},
						error: function() {
							topifyConsole.warn( 'error loading: Viglink' );
						}
					}
				);
			}
			return true;
		}
	}

	// Adding classes to skip viglink
	page.classList.add( 'nolinks', 'nooptimize', 'norewrite' );
}
function addShareThrough( state ) {
	if( isShareThrough( state ) && !loaded.sharethrough ) {
		postscribe(
			getBody(),
			'<script id="sharethrough_js" type="text/javascript" src="//native.sharethrough.com/assets/sfp.js"></script>',
			{
				done: function() {
					topifyConsole.info( "loading ShareThrough js tag" );
					loaded.sharethrough = true;
				},
				error: function() {
					topifyConsole.warn( 'error loading: ShareThrough');
				}
			}
		);
	}
}
function loadNetSeer( state ) {
	if( isNetseer( state ) && !loaded.netSeer ) {
		// let's ensure it's not there already
		let netseer_js = document.querySelectorAll( 'script#netseer_js' );
		if( netseer_js && netseer_js.length ) {
			netseer_js.forEach( function( item ) {
				item.parentNode.removeChild( item );
			} );
		}

		postscribe(
			getBody(),
			'<script async="true" id="netseer_js" type="text/javascript" src="//ps.ns-cdn.com/dsatserving2/scripts/ns_vmtag.js"></script>',
			{
				done: function() {
					topifyConsole.info( "loading netSeer js tag" );
					loaded.netSeer = true;
				},
				error: function() {
					topifyConsole.warn( 'error loading: netSeer');
				}
			}
		);
	}
}
function loadIframeMessenger( state ) {
	usesIframeMessenger( state );

	if( is.homePageInContentAdUnit ) {
		try {
			postscribe(
				getBody(),
				'<script id="vsIframeMessenger" type="text/javascript" src="//assets2.topify.com/vendor/vs/vsIframeMessenger_1.0.js"></script>',
				{
					done: function() {
						topifyConsole.info( "loading vsIframeMessenger" )
					},
					error: function() {
						topifyConsole.warn( 'error loading: vsIframeMessenger' );
					}
				}
			);
		} catch( e ) {
			topifyConsole.error( 'vsIframeMessenger Error:', e );
		}
	}
	try {
		if( is.VSInterstitial ) {
			postscribe(
				getBody(),
				'<script id="vsInterstitial" type="text/javascript" src="//assets2.topify.com/vendor/vs/vsInterstitialAd_2.0.js"></script>',
				{
					done: function() {
						topifyConsole.info( "loading vsInterstitialAd" )
					},
					error: function() {
						topifyConsole.warn( 'error loading: vsInterstitialAd' );
					}
				}
			);
		}
	} catch( e ) {
		topifyConsole.error( 'vsInterstitialAd Error:', e );
	}
}
function loadSolveMedia( state ) {
	try {
		let solvemediaData = state.ustate.solvemedia ? state.ustate.solvemedia : false;

		if( solvemediaData === false ) {
			return;
		}

		window.SMInformation = JSON.parse( solvemediaData.SMInformation );
		postscribe(
			getBody(),
			'<script id="solvemedia_script" type="text/javascript" src="' + solvemediaData.js + '"></script>',
			{
				done: function() {
					topifyConsole.info( "loading solveMedia js" );
				},
				error: function() {
					topifyConsole.warn( 'error loading: solveMedia' );
				}
			}
		);
	} catch( e ) {
		topifyConsole.error( 'solveMedia Error:', e );
	}
}

export function preLoadTaboola() {
	return ( dispatch, getState ) => {
		isTaboola( getState() );

		if( is.taboola ||  is.taboola_widget ) {
			window._taboola = window._taboola || [];
			_taboola.push( { article: 'auto' } );

			postscribe(
				getBody(),
				'<script id="taboola_script" type="text/javascript" src="//cdn.taboola.com/libtrc/verticalscope-network/loader.js"></script>',
				{
					done: function() {
						topifyConsole.info( "loading taboola loader" );
					},
					error: function() {
						topifyConsole.warn( 'error loading: Taboola loader' );
					}
				}
			);

		}
	}
}
export function triggerCaptify( query ) {
	// Clear previous pixel
	let captify_js = document.getElementById( 'captify_js' );
	if( captify_js ) {
		captify_js.parentNode.removeChild( captify_js );
	}

	if( is.VS !== true ) {
		return true;
	}

	// process keywords: limit to 40, join +
	let captify_kw_limit = 40;
	window.captify_kw_query_11942 = query.trim().split( /\s+/, captify_kw_limit ).join( '+' );

	postscribe(
		getBody(),
		'<script id="captify_js" async="true" type="text/javascript" src="//p.cpx.to/p/11942/px.js" ></script>',
		{
			done: function() {
				topifyConsole.info( "loading Captify js tag, query:", window.captify_kw_query_11942 );
			},
			error: function() {
				topifyConsole.warn( 'error loading: Captify' );
			}
		}
	);
}

// Secondary ads
export function checkAdsPermissions( currentForumId = false ) {
	return ( dispatch, getState ) => {
		let state = getState(),
			forumSite = state.topifyPresets.forumSite,
			ustate = state.ustate,
			subforums_secondary_ads = forumSite.secondaryAdForumIDs ? JSON.parse( forumSite.secondaryAdForumIDs ) : [],
			forumId = typeof currentForumId === 'number' ? currentForumId : false,
			usergroups_no_ads = forumSite.noAdGroupIDs ? JSON.parse( forumSite.noAdGroupIDs ) : [],
			user_groups = ustate.id ? ( ustate.membergroupids ? ustate.membergroupids : [ ustate.usergroupid ] ) : [];

		if( forumId === false ) {
			return;
		}

		adsPermissions = {
			noAdsPermissions: false,
			secondaryAds: false
		};

		// Are we browsing a subforum set for "Secondary Ads"
		if( subforums_secondary_ads.length > 0 ) {
			adsPermissions.secondaryAds = (
				forumSite.isVS &&
				( subforums_secondary_ads.findIndex( function( f_id ) {
					let f_id_int = parseInt( f_id );
					return ( f_id_int === forumId || f_id_int === -999 );
				} ) >= 0 )
			);
		}

		// Is the user member of a "No Ads User Group"?
		if( user_groups.length > 0 && usergroups_no_ads.length > 0 ) {
			adsPermissions.noAdsPermissions = usergroups_no_ads.some( function( groupId ) {
				let groupId_int = parseInt( groupId );
				return ( user_groups.findIndex( function( usergroup ) {
					let usergroup_int = parseInt( usergroup );
					return ( usergroup_int === groupId_int );
				} ) >= 0 );
			} );
		}

		topifyConsole.log( 'Ads Permissions', adsPermissions );

		dispatch( setAdsPermissions( adsPermissions ) );
	};
}
export function loadSecondaryAds( type, props, callbackFunc, onErrorFunc ) {
	return ( dispatch, getState ) => {
		switch( type ) {
			case 'rubicon':
				loadRubicon( getState(), props, callbackFunc, onErrorFunc );
		}
	};
}

function loadRubicon( state, props = {}, callbackFunc, onErrorFunc ) {
	let adSizeRubicon = null,
		_rubiconContanier = document.getElementById( props.container );

	if( !props.size || props.size.length < 2 || !_rubiconContanier ) {
		topifyConsole.warn( 'Rubicon Ad incorrect data provided', props );
		if( onErrorFunc ) {
			onErrorFunc();
		}
		return false;
	}

	// Find the Rubicon size
	let RubiconAdSizesMap = {
		"468x60": 1,
		"728x90": 2,
		"120x600": 8,
		"160x600": 9,
		"300x600": 10,
		"300x250": 15,
		"336x280": 16,
		"320x50": 43,
		"300x50": 44,
		"300x1050": 54,
		"970x90": 55,
		"970x250": 57,
		"1000x90": 58,
		"320x480": 67,
		"1800x1000": 68,
		"480x320": 101,
		"768x1024": 102
	};
	let adSize = props.size[0] + 'x' + props.size[1];

	if( RubiconAdSizesMap[ adSize ] ) {
		adSizeRubicon = RubiconAdSizesMap[ adSize ];
	} else {
		topifyConsole.warn( 'Rubicon Ad incorrect size provided', props );
		if( onErrorFunc ) {
			onErrorFunc();
		}
		return false;
	}

	// force iframe size based on ad size
	_rubiconContanier.style.width = `${ props.size[0] }px`;
	_rubiconContanier.style.height = `${ props.size[1] }px`;

	// OnLoad event
	_rubiconContanier.onload = callbackFunc;

	let rp_site = '25062',
		rp_zonesize = `97080-${ adSizeRubicon }`;

	let iFrameContent = `<!DOCTYPE html><html><head><title>rubicon ad</title><style type="text/css">body{margin:0;padding:0;}</style><script>window.rp_account = '1019'; window.rp_site = '${ rp_site }'; window.rp_zonesize = '${ rp_zonesize }'; window.rp_adtype = 'js'; window.rp_smartfile = ''; window.rp_kw = '${ state.topifyPresets.forumSite.f_site_name }';</script><script type="text/javascript" src="//ads.rubiconproject.com/ad/1019.js"></script></head><body></body></html>`;

	let iFrameDoc = _rubiconContanier.contentWindow.document;
	// Clear and Write the content
	iFrameDoc.open();
	iFrameDoc.write( iFrameContent );
	iFrameDoc.close();

	topifyConsole.log( 'rubicon ad added', props, rp_site, rp_zonesize );
}

// Refresh some libraries
function refreshLotame() {
	// Starting and/or Refreshing Lotame
	if( loaded.Lotame ) {
		if( ( typeof _lotameObj === 'undefined' || !_lotameObj ) && typeof _cc0 !== 'undefined' ) {
			// create a new object with ajax tag functionality
			window._lotameObj = new _cc0.ajax();
		}

		if( _lotameObj ) {
			// this will result in the firing of a sync pixel
			_lotameObj.bcpa( true, true, true );
			topifyConsole.log( 'Lotame triggered' );
		}
	}
}
function setTargetingLotame_ccauds() {
	if( is.Lotame && loaded.Lotame_ccauds ) {

		if( typeof ccauds !== "undefined" ) {
			( function( ccauds ) {
				let aud_abbr = [], audience = ccauds.Profile.Audiences.Audience;
				for( let cci = 0; cci < audience.length; cci++ ) {
					aud_abbr.push( audience[ cci ].abbr );
				}
				googletag.cmd.push( () => {
					googletag.pubads().setTargeting( "aud_abbr", aud_abbr );
					topifyConsole.log( 'setTargeting Lotame ccauds Audience ', aud_abbr );
				} );
			} )( ccauds );
		}

		googletag.cmd.push( () => {
			if( typeof ccauds !== "undefined" && typeof ccauds.Profile.tpid !== "undefined" && ccauds.Profile.tpid !== "" ) {
				googletag.pubads().setTargeting( "tpid", ccauds.Profile.tpid );
				topifyConsole.log( 'setTargeting Lotame ccauds tpid ', ccauds.Profile.tpid );
			} else {
				googletag.pubads().setTargeting( "tpid", "0" );
				topifyConsole.log( 'setTargeting Lotame ccauds ', 0 );
			}
		} );
	}
}
function refreshVSAPI( state ) {
	// Do we use vsAPI?
	if( loaded.VSAPI ) {
		topifyConsole.log( 'refresh VSAPI' );
		// Trigger vsapi track if we have to
		if( state.threadview.result.posts && state.threadview.result.posts.length > 0 && state.infiniteScroll.page ) {
			topifyConsole.log( 'Clear and init vsApi call for post page for user ', state.ustate.id);
			_vs_beacon.userId = state.ustate.id; // set user id, just in case
			_vs_observe.clear();
			_vs_lotame.init( window.location.hostname, state.threadview.result.posts );

			// What posts are in this page?
			let pageIndex = state.threadview.pages.indexOf( state.infiniteScroll.page ),
				page_size = state.ui.userSettings.pageSize,
				postsInPage = state.threadview.result.posts.slice( pageIndex * page_size, (pageIndex + 1) * page_size );

			// For each post on the page:
			postsInPage.forEach( function( post, index ) {
				if( document.getElementById( 'post_message_' + post ) ) {
					_vs_observe.addPostElement(
						document.getElementById( 'post_container_' + post ),
						document.getElementById( 'post_message_' + post ),
						post,
						parseInt( state.threadview.entities.posts[ post ].topic ),
						parseInt( state.threadview.entities.posts[ post ].forum ),
						parseInt( state.threadview.entities.posts[ post ].forumUser ),
						index + 1
					);
				}
			});
		}
	}
}
export function refreshTaboola( type ) {
	if( is.taboola_widget || is.taboola ) {
		topifyConsole.groupCollapsed( "taboola ads" );
		topifyConsole.log( "taboola type", type );

		let taboolaData = {},
			_taboolaAd_id = '',
			_taboolaAd_placement = '';

		switch( type ) {
			case 'taboola':
				if( is.taboola ) {
					_taboolaAd_id = 'taboola-mobile-below-article-thumbnails';

					taboolaData = {
						mode: 'thumbnails-f',
						container: _taboolaAd_id,
						placement: 'Mobile Below Article Thumbnails',
						target_type: 'mix'
					};
				}
				break;

			case 'recirculation':
				if( is.taboola_widget ) {
					_taboolaAd_id = 'taboola-mid-article-stream-thumbnails';
					_taboolaAd_placement = is.taboola_widget;

					// clear current slot
					let currentTaboola = document.querySelectorAll( '#taboola-mid-article-stream-thumbnails div.trc_rbox' );
					if( currentTaboola && currentTaboola.length ) {
						currentTaboola.forEach( function( item ) {
							item.parentNode.removeChild( item );
						});
					}

					taboolaData = {
						mode: 'organic-thumbnails-a',
						container: _taboolaAd_id,
						placement: _taboolaAd_placement,
						target_type: 'mix'
					};
				}
				break;
		}

		if( window._taboola && taboolaData.container && document.getElementById( _taboolaAd_id ) ) { // Only if container exists
			topifyConsole.log( "taboola push data", taboolaData );
			window._taboola.push( taboolaData );
			topifyConsole.log( "taboola flush" );
			window._taboola.push( { flush: true } );
		} else {
			topifyConsole.log( 'not loaded' );
		}
		topifyConsole.groupEnd( "taboola ads" );
	}
}
export function refreshRevContent() {
	return ( dispatch, getState ) => {
		let state = getState();
		if( isRevContent( state ) ) {
			let f_revContent = state.topifyPresets.forumSite.f_revcontent || "",
				revContentId = f_revContent.match( /(\d+)\s*,\s*(\d+)/ );

			let prevjs = document.querySelectorAll( '#revContent_js, script[id^="rc2js_beacon"]' );
			if( prevjs && prevjs.length ) {
				prevjs.forEach( function( item ) {
					item.parentNode.removeChild( item );
				});
			}

			if( revContentId.length === 3 ) {
				let revContent_code = "\
					(function(){function ad_block_test(e,o){if(\"undefined\"!=typeof document.body){var t=\"0.1.2-dev\",\
					o=o?o:\"sponsorText\",n=document.createElement(\"DIV\");n.id=o,n.style.position=\"absolute\",\
					n.style.left=\"-999px\",n.appendChild(document.createTextNode(\"&nbsp;\")),document.body.appendChild(n),\
					setTimeout(function(){if(n){var o=0==n.clientHeight;try{}catch(d){console&&console.log&&console.log(\"ad-block-test error\",d)}\
					e(o,t),document.body.removeChild(n)}},175)}}ad_block_test(function(is_blocked){\
					var widget_id=" + revContentId[ 1 ] + ";if(is_blocked===true)widget_id=" + revContentId[ 2 ] + ";\
					var referer=\"\";try{if(referer=document.referrer,\"undefined\"==typeof referer)throw\"undefined\";}catch(exception){\
					referer=document.location.href,(\"\"==referer||\"undefined\"==typeof referer)&&(referer=document.URL)}referer=referer.substr(0,700);\
					var rcel=document.createElement(\"script\");rcel.id=\"rc_\"+Math.floor(Math.random()*1E3);\
					rcel.type=\"text/javascript\";rcel.src=\"http://trends.revcontent.com/serve.js.php?w=\"+widget_id+\"&t=\"+rcel.id+\"\
					&c=\"+(new Date).getTime()+\"&width=\"+(window.outerWidth||document.documentElement.clientWidth)+\"&referer=\"+referer+\"\
					&is_blocked=\"+is_blocked;rcel.async=true;\
					var rcds=document.getElementById(\"rcjsload_vs1vs1\");rcds.appendChild(rcel)})})();\
				";

				postscribe(
					getBody(),
					"<script async id='revContent_js' type='text/javascript'>" + revContent_code + "</script>",
					{
						done: function() {
							topifyConsole.info( "loading revContent code" );
						},
						error: function() {
							topifyConsole.warn( 'error loading: revContent' );
						}
					}
				);
			}
		}
	}
}
export function refreshGoogleAds( state ) {
	topifyConsole.log( 'refreshGoogleAds' );

	try {
		const path = parsePath( state.routing.locationBeforeTransitions.pathname ),
			ustate = state.ustate,
			usergroup = ( typeof ustate.displaygrouptitle !== 'undefined' && ustate.displaygrouptitle ? ustate.displaygrouptitle : 'guest' ),
			metaPath = state.meta.path && state.meta.path.length ? state.meta.path[0] : false,
			currentSubforum_id = metaPath ? metaPath.id : -1,
			currentSubforum_name = metaPath ? metaPath.title : '';

		let currentLegacyUrl = '',
			PageID = 0;

		switch( path[1] || path[0] ) {
			case 'topics':
				PageID = ( typeof state.meta.threadid !== 'undefined' ? state.meta.threadid : 0 );
				currentLegacyUrl = state.threadview.entities.topics ? state.threadview.entities.topics[ PageID ].href : '';
				break;
			case 'forums':
				if( path[2] ) {
					currentLegacyUrl = state.forumview.entities.forums ? state.forumview.entities.forums[ state.forumview.forumId ].href : '';
				} else {
					currentLegacyUrl = state.topifyPresets.forumSite.f_url;
					PageID = 'Homepage';
				}
				break;
			case 'portal':
				let portalpage = state.portalpage;
				currentLegacyUrl = portalpage.result && portalpage.result.portalpage ? state.topifyPresets.forumSite.f_url.replace( /\/$/, '' ) + '/' + portalpage.result.portalpage[0] + '.html' : '';
				PageID =  !( portalpage.result && portalpage.result.portalpage ) ? 'cmps' : ( /insurance/i.test( portalpage.result.portalpage[0] ) ? 'insurance' : portalpage.result.portalpage[0] );
				break;
			case '/':
				currentLegacyUrl = state.topifyPresets.forumSite.f_url;
				PageID = 'Homepage';
				break;
		}

		// ensure targeting for Lotame ccauds are set
		setTargetingLotame_ccauds();

		window.googletag.cmd.push( () => {
			// Sharethrough targetting
			if( is.sharethrough ) {
				googletag.pubads().setTargeting( "strNativeKey", state.topifyPresets.forumSite.f_sharethrough );
			}

			// update the dynamic targeting values
			googletag.pubads().setTargeting( 'forum_id', currentSubforum_id + '' );
			googletag.pubads().setTargeting( 'forum_name', currentSubforum_name );
			googletag.pubads().setTargeting( 'group_id', usergroup );
			googletag.pubads().setTargeting( 'registered', isUserLoggedIn + '' );
			googletag.pubads().setTargeting( 'PageID', PageID + '' );

			googletag.pubads().set( "page_url", currentLegacyUrl );

			let page = document.getElementById( 'page' ),
				page_backgroundColor = page ? window.getComputedStyle( page ).getPropertyValue('background-color' ) : '';
			googletag.pubads().set( 'adsense_background_color', page_backgroundColor );
		} );

	} catch( e ) {
		topifyConsole.error( 'refreshGoogleAds setTargeting ERROR ', e );
	}
}

// Create a observers for DOM mutations on head and body
const observerConfig = { childList: true }; // configuration of the observer
let checkExcludedFromDelete = ( node ) => {
		// urls to exclude from deletion
		let excludeSRC = [
				'google-analytics.com/ga.js',
				'google-analytics.com/analytics.js',
				'google.com/adsense/search/async-ads.js',
				'googletagservices.com/tag/js/gpt.js',
				'/prebid-.*.js'
			],
			// Ids
			excludeIDs = [
				'vsIframeMessenger', 'vsInterstitial',
				'comScoreBeacon', 'captify_js',
				'LOTCC_8060', 'lotame_ccauds_js'
			],
			excludeStyles = [ 'trc_rbox_container' ];

		switch( node.nodeName ) {
			case 'SCRIPT':
				return node.src && (
					( node.id && excludeIDs.some( ( js ) => node.id === js ) ) || // if we have id check it first
					excludeSRC.some( ( js ) => ( new RegExp( js, 'i' ) ).test( node.src ) )
				);

			case 'STYLE':
				return excludeStyles.some( ( style ) => ( new RegExp( style ) ).test( node.textContent ) );
		}

		return false;
	},
	trackAddedNodes = ( mutations ) => {
		mutations.forEach( ( mutation ) => {
			// convert nodeList into an array
			// avoiding nodeList.forEach polyfill for iOS8 + Chrome
			[ ...mutation.addedNodes ].forEach( node => {
				if( checkExcludedFromDelete( node ) === false ) {
					insertedNodes.push( node );
				}
			} );

			// If there are removed nodes, remove them from our array
			if( mutation.removedNodes.length ) {
				[ ...mutation.removedNodes ].forEach( ( removed ) => {
					let index = insertedNodes.findIndex( e => e === removed );
					if( index >= 0 ) {
						insertedNodes.splice( index, 1 );
					}
				});
			}
		} );
	},
	_mutationObserver_Body = new MutationObserver( trackAddedNodes ),
	_mutationObserver_Head = new MutationObserver( trackAddedNodes );

// Cleans elements from previous page view
export function cleanOldAdElements() {
	topifyConsole.groupCollapsed( "cleaning ad elements" );
	topifyConsole.time("cleaning ad elements");

	// Stop Observers
	_mutationObserver_Head.disconnect();
	_mutationObserver_Body.disconnect();

	// Elements
	let elementsToRemove = [ ...insertedNodes ];

	// Swoop
	delete window.SPX;

	//eXelate
	if( typeof xl8iframe !== 'undefined' ) {
		try {
			elementsToRemove.push( xl8iframe );
		} catch( e ) { /* ignore */}
	}

	// netseer
	// when netseer don't use the banner anymore just throws them out of page >:|
	// let's remove them
	let netSeerKeys = [];
	if( window.NETSEER && window.NETSEER.assignedBanners ) {
		[ ...window.NETSEER.assignedBanners ].forEach( ( item, i ) => {
			if( parseInt( item.style.top ) < 0 ) { // been removed by netseer
				netSeerKeys.push( i );
			}
		} );
		netSeerKeys.reverse().forEach( i => window.NETSEER.assignedBanners.splice( i, 1 ) );
	}

	// remove the elements
	elementsToRemove.forEach( item => {
		try {
			item.parentNode.removeChild( item );
		} catch( e ) { /* ignore */ }
	} );

	topifyConsole.timeEnd("cleaning ad elements");
	topifyConsole.log( 'Total Elements:', elementsToRemove.length );
	topifyConsole.groupEnd( "cleaning ad elements" );

	insertedNodes = [];
	_mutationObserver_Head.observe( getHead(), observerConfig );
	_mutationObserver_Body.observe( getBody(), observerConfig );
}

// Google analytics
function isValidAnalyticsID(value) {
	let pattern = new RegExp("^UA-\\d{4,10}(-\\d{1,4})?$");
	return pattern.test(value);
}
function getTrackingUrl( state ) {
	let rtnUrl = '/';
	try {
		if( state.routing.locationBeforeTransitions ) {
			rtnUrl = state.routing.locationBeforeTransitions.pathname;
			for( let q in state.routing.locationBeforeTransitions.query ) {
				rtnUrl +=  ( rtnUrl.lastIndexOf( '?' ) < 0 ? '?' : '&' );
				if( q === 'page' && ( state.meta.page || state.infiniteScroll.page ) ) {
					rtnUrl += q + '=' + (
							state.routing.locationBeforeTransitions.query.q ? // it's a search, grab query.page
								state.routing.locationBeforeTransitions.query.page :
								( state.infiniteScroll.page || state.meta.page )
						);
				} else {
					rtnUrl += q + '=' + state.routing.locationBeforeTransitions.query[ q ];
				}
			}
		} else {
			// let's grab by the current url
			throw true;
		}
	} catch( e ) {
		if( window.location.hash && (window.location.hash.length > 1) ) {
			rtnUrl = window.location.hash.substr( 1 );

			if( rtnUrl.lastIndexOf( '_k=' ) >= 0 ) {
				rtnUrl = rtnUrl.substring( 0, rtnUrl.lastIndexOf( '_k=' ) - 1 );
			}
		}
	}

	return rtnUrl;
}

export function trackPageView() {
	return ( dispatch, getState ) => {
		const state = getState();
		// Defined dimensions:
		// dimension1 = forumId - hit
		// dimension2 = appType - session
		// dimension3 = forumUserGroup - hit
		let page = getTrackingUrl( state ),
			f_analytics_id = state.topifyPresets.forumSite.f_analytics_id,
			f_id = state.topifyPresets.forumSite.f_id + '',
			usergroup = ( typeof state.ustate.displaygrouptitle !== 'undefined' && state.ustate.displaygrouptitle ? state.ustate.displaygrouptitle : 'guest' ),
			data = {
				page: page,
				appName: 'Topify Browser V3',
				dimension1: f_id,
				dimension3: usergroup
			};

		ga( analyticsTrackerName + '.set', data );
		ga( analyticsTrackerName + '.send', 'pageview' );
		topifyConsole.info( 'GA PAGEVIEW ', data );

		if( f_analytics_id && isValidAnalyticsID( f_analytics_id ) ) {
			if( is.VS ) {
				// We do special handling for VerticalScope forums to record a specific domain
				// as well as the current user's group in a custom variable.
				if( process.env.NODE_ENV === 'production' && _gaq ) {
					_gaq.push(
						[ '_setAccount', f_analytics_id ],
						[ '_setDomainName', state.topifyPresets.forumSite.f_site_name ],
						[ '_setCustomVar', 1, 'grp', usergroup ],
						[ '_setCustomVar', 2, 'topify', '1' ],
						[ '_trackPageview', page ]
					);
					topifyConsole.info( 'GA PAGEVIEW (VS) - analyticsId: ' + f_analytics_id + ' - page: ' + page + ' - forumSiteId: ' + f_id + ' - domain: ' + state.topifyPresets.forumSite.f_site_name + ' - group: ' + usergroup + ' - topify: 1' );
				}

			} else {
				// all non VS
				ga( function() {
					if( !ga.getByName( f_id ) ) {
						ga( 'create', f_analytics_id, { name: f_id } );
						topifyConsole.info( 'GA PAGEVIEW - create tracker: ' + f_analytics_id + ' - forumId: ' + f_id );
					}
					data = {
						page: page,
						appName: 'Topify Browser V3'
					};

					ga( f_id + '.set', data );
					ga( f_id + '.send', 'pageview' );

					topifyConsole.info( 'GA PAGEVIEW - analyticsId: ' + f_analytics_id + ' - data: ', data );
				} );
			}
		}
	};
}
export function trackGAEvent( useForumAnalyticsId, label = 'unknown', optionalCategory = 'topify', optionalAction = 'event', optionalValue = 0, optionalForcedPage ) {
	return ( dispatch, getState ) => {
		const state = getState();
		let page = optionalForcedPage || getTrackingUrl( state ),
			f_analytics_id = state.topifyPresets.forumSite.f_analytics_id,
			f_id = state.topifyPresets.forumSite.f_id + '',
			usergroup = ( typeof state.ustate.displaygrouptitle !== 'undefined' && state.ustate.displaygrouptitle ? state.ustate.displaygrouptitle : 'guest' ),
			data = {
				hitType: 'event',
				eventCategory: optionalCategory,
				eventAction: optionalAction,
				eventLabel: label,
				eventValue: optionalValue,

				page: page,
				dimension1: f_id,
				dimension3: usergroup
			};

		ga( function() {
			ga( analyticsTrackerName + '.send', data );
			topifyConsole.log( 'GA EVENT - analyticsId: ' + f_analytics_id + ' - data: ', data );
		} );

		if( useForumAnalyticsId && f_analytics_id && isValidAnalyticsID( f_analytics_id ) ) {
			// reset values for forum analytics
			optionalCategory = 'topify';
			optionalAction = 'event';

			if( is.VS ) {
				// We do special handling for VerticalScope forums to record a specific domain
				// as well as the current user's group in a custom variable.
				if( process.env.NODE_ENV === 'production' && _gaq ) {
					_gaq.push(
						[ '_setAccount', f_analytics_id ],
						[ '_set', 'page', page ],
						[ '_setDomainName', state.topifyPresets.forumSite.f_site_name ],
						[ '_setCustomVar', 1, 'grp', usergroup ],
						[ '_setCustomVar', 2, 'topify', '1' ],
						[ '_trackEvent', optionalCategory, optionalAction, label, optionalValue, true ]
					);
					topifyConsole.log( 'GA EVENT (VS) - analyticsId: ' + f_analytics_id + ' - page: ' + page + ' - forumSiteId: ' + f_id + ' - domain: ' + state.topifyPresets.forumSite.f_site_name + ' - group: ' + usergroup + ' - topify: 1 - ' + optionalCategory + ' - ' + optionalAction + ' - ' + label + ' - ' + optionalValue );
				}
			} else {
				// all non VS
				data.eventCategory = 'topify';
				data.eventAction = 'event';
				data.appName = 'Topify Browser V3';
				delete data.dimension1;
				delete data.dimension3;

				ga( function() {
					ga( f_id + '.send', data );
					topifyConsole.log( 'GA EVENT - analyticsId: ' + f_analytics_id + ' - forumId: ' + f_id + ' - data: ', data );
				} );
			}
		}
	};
}

// Gets user location if they allow us
export function getGeoLocation() {
	return ( dispatch, getState ) => {
		const state = getState();
		let geoLocation = {
			allow: true,
			error: false,
			latitude: '',
			longitude: '',
			timestamp: 0
		};

		if( state.ads.geoLocation.allow === false ) {
			topifyConsole.info( 'geoLocation NOT allowed' );
			return;
		}

		// Checking last geo check
		if( !useSSL || new Date().getTime() - geoLocationRefresh < state.ads.geoLocation.timestamp ) {
			return true;
		}

		geoLocation.timestamp = new Date().getTime();

		navigator.geolocation.getCurrentPosition(
			function( position ) {
				geoLocation.latitude = position.coords.latitude;
				geoLocation.longitude = position.coords.longitude;
				topifyConsole.log( 'geoLocation updated: ', geoLocation );

				// Updating googletag targeting
				if( window.googletag ) {
					topifyConsole.log( 'Targetting googleads geoLocation' );

					window.googletag.cmd.push( () => {
						googletag.pubads().setLocation( geoLocation.latitude, geoLocation.longitude );
					} );
				}
				dispatch( setGeoLocation( geoLocation ) );
			}, function( error ) {
				switch( error.code ) {
					case error.PERMISSION_DENIED:
						geoLocation.allow = false;
						break;
					case error.POSITION_UNAVAILABLE:
					case error.TIMEOUT:
					case error.UNKNOWN_ERROR:
						geoLocation.error = true;
						break;
				}
				dispatch( setGeoLocation( geoLocation ) );
			},
			{
				timeout: 10 * 1000
			}
		);
	}
}

// Init Ads: check and loads general libraries, on first load
export function initAdLibraries() {
	topifyConsole.info( 'Init Ads' );

	return ( dispatch, getState ) => {
		let state = getState();

		// pass in the target node, as well as the observer options
		_mutationObserver_Head.observe( getHead(), observerConfig );
		_mutationObserver_Body.observe( getBody(), observerConfig );

		// Run pre-options
		isVS( state );
		dispatch( isLoggedIn() );

		// We need to load these libraries as soon as possible
		loadIframeMessenger( state );

		isLotame( state );
		loadVSAPI( state );

		get_ExelateUrl( state );

		initEvents( dispatch );

		// Load the libraries
		initGoogleAds( state );
		addLotame();
		addLotame_ccauds();
		addVibrantjs( state );
		addCustomScripts( state );
		isNetseer( state );
		loadNetSeer( state );

		addComScore( state );
		addShareThrough( state );

		// First load
		addExelate( state );
	};
}

// On every page view
export function onPageView( triggerValues = null ) {
	topifyConsole.info( 'Ads onPageView', triggerValues );

	pageCounter++;

	if( pageCounter > 1 ) {
		cleanOldAdElements();
	}

	if( triggerValues && 'undefined' !== typeof triggerValues.captify ) {
		// Captify needs to be triggered once per section
		triggerCaptify( triggerValues.captify );
	}

	return ( dispatch, getState ) => {
		let state = getState();

		dispatch( isLoggedIn() );
		addSwoop( state );
		loadViglink( state );
		loadSolveMedia( state );
		loadNetSeer( state );

		dispatch( setGPTCorrelator( true ) );

		if( pageCounter > 1 ) {
			dispatch( getGeoLocation() );
			trackComScore( state );
			refreshLotame();
			addCustomScripts( state );
			refreshVSAPI( state );
			refreshGoogleAds( state );
			addExelate( state );

		} else {
			refreshGoogleAds( state );
		}

		if( goInterstitial() ) {
			dispatch( showInterstitial() );
		} else if( state.ads.showInterstitial ) {
			dispatch( hideInterstitial() );
		}
	}
}


// WEBPACK FOOTER //
// ./src/actions/adsActions.js